// this is referenced from webpack config, make sure it is matching regex in it when changing.
export const badgingVersion = '2.0.1';
